//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';
// import Transactions from '~/views/UserMerchant/Transactions/Table.vue';
import Stores from '~/views/MerchantsStores/Stores/Table.vue';
import Products from '~/views/MerchantsProducts/Products/Table.vue';
import Invoices from '~/views/MerchantsInvoices/Invoices/Table.vue';
import Fees from '~/views/MerchantsFees/Fees/Table.vue';

export default {
  components: {
    // Transactions,
    Stores,
    Products,
    Invoices,
    Fees,
  },

  computed: {
    ...mapState('user', ['user']),

    merchantId() {
      return this.user.id;
    },
  },

  async mounted() {
    this.setGeneralLoader(true);
    await Promise.allSettled([
      // this.load(),
      this.loadStores({ merchantIds: [this.merchantId] }),
      this.loadProducts({ merchantIds: [this.merchantId] }),
      this.loadInvoices({ merchantIds: [this.merchantId] }),
      this.loadFees({ serviceMerchantId: [this.merchantId] }),
      this.loadProviders(),
      this.loadCurrencies(),
    ]);
    this.setGeneralLoader(false);
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader']),
    // ...mapActions('userMerchant', {
    //   load: 'loadData',
    // }),
    ...mapActions('merchantsStores', {
      loadStores: 'loadData',
    }),
    ...mapActions('merchantsProducts', {
      loadProducts: 'loadData',
    }),
    ...mapActions('merchantsInvoices', {
      loadInvoices: 'loadData',
    }),
    ...mapActions('merchantsFees', {
      loadFees: 'loadIndividualData',
      loadProviders: 'loadProviders',
      loadCurrencies: 'loadCurrencies',
    }),
  },
};
